import {useEffect,useState} from 'react';
import {useLocation} from 'react-router-dom';

const empty=()=>({online:navigator.onLine,checked:0,lastSync:0,failed:false,checking:true});
export const useConnection=(api,scope,identity)=>{
  const {pathname}=useLocation();
  const [state,setState]=useState(empty),[clock,setClock]=useState(Date.now());
  useEffect(()=>{
    let live=true,pending=false;
    const generation=Symbol('connection'),failures=new Set(),controller=new AbortController();
    setState(empty());
    const relevant=config=>config?.method==='get'&&(scope==='trader'?config.url?.startsWith('/api/trader/')&&!config.url.includes('/auth/'):scope==='manager'?config.url?.startsWith('/manager/'):config.url?.startsWith('/')&&!/^\/(auth|navigation|workspaces|modules|manager)(\/|$)/.test(config.url));
    const key=config=>config.url.split('?')[0];
    const watched=new WeakSet();
    const requestId=api.interceptors.request.use(config=>{
      if(relevant(config)){
        config.syncGeneration=generation;
        if(config.signal&&!watched.has(config.signal)){
          watched.add(config.signal);
          config.signal.addEventListener('abort',()=>{
            if(live){failures.delete(key(config));setState(s=>({...s,failed:failures.size>0}));}
          },{once:true});
        }
      }
      return config;
    });
    const responseId=api.interceptors.response.use(response=>{
      if(live&&response.config.syncGeneration===generation){failures.delete(key(response.config));setState(s=>({...s,lastSync:Date.now(),failed:failures.size>0}));}
      return response;
    },error=>{
      if(live&&error.code!=='ERR_CANCELED'&&error.config?.syncGeneration===generation){failures.add(key(error.config));setState(s=>({...s,failed:true}));}
      return Promise.reject(error);
    });
    const check=async()=>{
      if(!live||pending||!navigator.onLine||document.visibilityState!=='visible')return;
      pending=true;setState(s=>({...s,checking:true}));
      try{
        if(scope==='trader')await api.get('/api/trader/me',{signal:controller.signal,timeout:8000});
        else await api.post('/sync',null,{signal:controller.signal,timeout:8000});
        if(live)setState(s=>({...s,checked:Date.now(),online:true,checking:false}));
      }catch(e){if(live)setState(s=>({...s,checked:0,checking:false}));}
      finally{pending=false;}
    };
    const online=()=>{setState(s=>({...s,online:true,checked:0,checking:true}));check();};
    const offline=()=>setState(s=>({...s,online:false,checking:false}));
    check();
    const timer=setInterval(check,30000),tick=setInterval(()=>setClock(Date.now()),1000);
    window.addEventListener('online',online);window.addEventListener('offline',offline);
    window.addEventListener('focus',check);document.addEventListener('visibilitychange',check);
    return()=>{live=false;controller.abort();clearInterval(timer);clearInterval(tick);api.interceptors.request.eject(requestId);api.interceptors.response.eject(responseId);window.removeEventListener('online',online);window.removeEventListener('offline',offline);window.removeEventListener('focus',check);document.removeEventListener('visibilitychange',check);};
  },[api,scope,identity,pathname]);
  const status=!state.online?'offline':!state.checked?(state.checking?'checking':'unreachable'):state.failed?'error':clock-state.checked>70000?'stale':state.lastSync&&clock-state.lastSync>45000?'stale':'connected';
  return {...state,status};
};